import { Redirect, useLocalSearchParams } from 'expo-router'

export default function FormCharts() {
  const { formToken, token, ...rest } = useLocalSearchParams<{ formToken: string; token: string }>()
  return (
    <Redirect
      href={
        `${process.env.EXPO_PUBLIC_GOTEN2_BASE_URL}/form/${formToken}/charts?token=${token}&${new URLSearchParams(rest as Record<string, string>).toString()}` as any
      }
    />
  )
}
